<template>
  <div class="carousel-map">
    <div
      :id="`swiper-container-${moduleData.module_id}`"
      class="swiper-container"
      :ref="`swiper-container-${moduleData.module_id}`">
      <div class="swiper-wrapper">
        <div
          v-for="(item,key) in moduleData.imgList"
          :key="key"
          class="swiper-slide">
          <img :src="item.img_url" alt>
        </div>
      </div>
      <div :id="`swiper-pagination-${moduleData.module_id}`" class="swiper-pagination" />
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import { openUrl } from '../index'
export default {
  name: 'CarouselMap',
  props: {
    moduleData: {
      type: Object
    }
  },
  mounted() {
    const vm = this
    new Swiper(`#swiper-container-${this.moduleData.module_id}`, {
      direction: "horizontal", // 水平方向切换
      loop: true, // 循环模式选项
      autoplay: {
        delay: 10000, // 自动切换时间
        disableOnInteraction: false
      },
      pagination: {
        el: `#swiper-pagination-${this.moduleData.module_id}`
      },
      on:{
        click: function(){
          const realIndex = vm.$refs[`swiper-container-${this.moduleData.module_id}`].swiper.realIndex
          if (!vm.moduleData.imgList[realIndex].url) return
          openUrl(vm.moduleData.imgList[realIndex].url)
        }
      }
    })
  }
}
</script>

<style lang="less" scoped>
.carousel-map .swiper-container {
  .swiper-wrapper .swiper-slide img {
    width: 100%;
  }
  .swiper-pagination {
    bottom: 0px;
    line-height: 1.55;
    /deep/ .swiper-pagination-bullet {
      width: 0.12rem;
      height: 0.12rem;
      background: #FFFFFF;
      opacity: 0.5;
      margin: 0 0.1rem;
      &.swiper-pagination-bullet-active {
        background: #FFFFFF;
        width: 0.34rem;
        opacity: 1;
        border-radius: 0.12rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modules/carousel-map.vue